import React, { useState, useEffect } from "react";
import { Cookie } from "@phosphor-icons/react";

const CookieBanner = () => {
  const isBrowser = typeof window !== "undefined"
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const hasAcceptedCookieConsent = isBrowser && sessionStorage.getItem(
      "cookieConsentAccepted"
    );
    if (!hasAcceptedCookieConsent && hasAcceptedCookieConsent !== "accepted") {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = (e) => {
    e.preventDefault();
    isBrowser && sessionStorage.setItem("cookieConsentAccepted", "accepted");
    setShowBanner(false);
  };

  const handleDecline = (e) => {
    e.preventDefault();
    isBrowser && sessionStorage.setItem("cookieConsentAccepted", "declined");
    setShowBanner(false);
  };

  return (
    <>
      {showBanner && (
        <div className="fixed bottom-2 bg-black z-50 flex flex-col md:flex-row md:justify-between  justify-center items-center p-10 md:p-7 gap-8 rounded-[20px] mx-5">
          <div className="text-white flex flex-col items-center justify-center md:block">
          <div className="w-full mb-5">
          <Cookie size={40} weight="fill" color="#f87268" />
          </div>
            <p className="mb-5 md:mb-2 text-[#cdd1db]">
              We respect your privacy and aim for the best website experience.
              By using our website, you agree to our use of cookies.
              <span>
                {` For more
              information, please read our `}</span>
               {/* in
              compliance with <a className="underline font-semibold hover:text-brand" href="https://gdpr-info.eu/">GDPR</a>. */}

              {/* <span>
                {` Allowing
              cookies enables a tailored experience, while disabling them may
              reduce personalization. Feel free to update your preferences
              anytime. Your consent remains valid for 12 months. For more
              information, please read our `}</span> */}
              <a
                href={`${process.env.Telecel_web_url}/privacy-policy`}
                className=" underline font-semibold hover:text-brand"
              >
                {`Privacy Policy`}
              </a>
           {` and `}
              <a
                href={`${process.env.Telecel_web_url}/cookie-policy`}
                className=" underline font-semibold hover:text-brand"
              >
                {`Cookie Policy`}
              </a>
              . Happy browsing!
            </p>
            <a 
            
            href={`${process.env.Telecel_web_url}/cookie-policy`}
              className="underline font-semibold hover:text-brand w-full md:w-auto">
              Learn more
            </a>
          </div>
          <div className="flex flex-col md:flex-row gap-4 md:gap-3 w-full md:w-auto">
            {/* <button
              onClick={handleDecline}
              className="font-bold py-2 px-6 rounded-3xl md:rounded-3xl bg-transparent border-2 border-telecel_white text-telecel_white hover:bg-body"
            >
              Decline
            </button> */}
            <button
              onClick={handleAccept}
              className="font-bold py-2 px-6 rounded-3xl md:rounded-3xl  bg-telecel_white  hover:bg-surface_default"
            >
              Accept
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
